import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import apiCall from "../components/Api/api";
// import parse from 'html-react-parser';

const CancellationPolicy = () => {
  return (
    <>
      <section className="banner_section-inner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/t&c_banner.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/t&c_banner.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
      </section>
      <section className="terms_wrapper">
        <Container lg>
          <Row className="pb-5 mb-5 margin_bottomfooter">
            <Col xs={12}>
              <div className="title_terms">
                <h2> Cancellation Policy </h2>
              </div>
            </Col>
            <Col xs={12}>
              <div className="title_terms">
                <h2>Coming Soon </h2>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CancellationPolicy;
